import type { CurrentUser } from "../lib/types";
import { Icon } from "./Icon";

const nav = [
  ["dashboard", "overview", "Overview"],
  ["calendar", "followups", "Follow-ups"],
  ["leads", "clients", "Clients"],
  ["link", "partners", "Partners"],
  ["user", "nodes", "Nodes"],
  ["bell", "assignments", "Assignments"],
  ["clock", "events", "Events"],
  ["report", "reports", "Reports"],
  ["report", "performance", "Performance"],
  ["zap", "proof", "Proof"],
  ["sheet", "pulse", "Pulse"],
  ["settings", "settings", "Settings"]
] as const;

export type CrmView = (typeof nav)[number][1];

export function Sidebar({
  activeView,
  onChangeView,
  user
}: {
  activeView: CrmView;
  onChangeView: (view: CrmView) => void;
  user: CurrentUser | null;
}) {
  return (
    <aside className="sidebar">
      <div className="brand">
        <div className="brand-mark">BL</div>
        <div>
          <strong>Builtlocally</strong>
          <span>Warm engine</span>
        </div>
      </div>

      <nav className="nav-list">
        {nav.map(([icon, view, label]) => (
          <button className={activeView === view ? "nav-item active" : "nav-item"} key={view} onClick={() => onChangeView(view)}>
            <Icon name={icon} />
            <span>{label}</span>
          </button>
        ))}
      </nav>

      <div className="sidebar-user">
        <div className="avatar">{(user?.name || "BL").slice(0, 2).toUpperCase()}</div>
        <div>
          <strong>{user?.name || "Builtlocally"}</strong>
          <span>{user?.role === "worker" ? "User" : "Owner"}</span>
        </div>
      </div>
    </aside>
  );
}
